/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_about_team_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toolverse is built and maintained by the Toolverse Team — a small, independent group of software engineers. The site is not owned by a media company, does not sell your data, and is funded by unobtrusive advertising.`)
};

const es_about_team_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toolverse está construido y mantenido por el Toolverse Team — un grupo pequeño e independiente de ingenieros de software. El sitio no pertenece a ninguna empresa de medios, no vende tus datos y se financia con publicidad discreta.`)
};

const de_about_team_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toolverse wird vom Toolverse Team entwickelt und betrieben — einer kleinen, unabhängigen Gruppe von Softwareingenieuren. Die Seite gehört keinem Medienunternehmen, verkauft deine Daten nicht und finanziert sich durch dezente Werbung.`)
};

const nl_about_team_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toolverse wordt gebouwd en onderhouden door het Toolverse Team — een kleine, onafhankelijke groep softwareontwikkelaars. De site is geen eigendom van een mediabedrijf, verkoopt je gegevens niet en wordt gefinancierd met onopvallende advertenties.`)
};

const fr_about_team_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toolverse est conçu et maintenu par la Toolverse Team — un petit groupe indépendant d’ingénieurs logiciels. Le site n’appartient à aucune entreprise média, ne vend pas vos données et est financé par une publicité discrète.`)
};

const it_about_team_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toolverse è costruito e mantenuto dal Toolverse Team — un piccolo gruppo indipendente di ingegneri software. Il sito non appartiene a un’azienda mediatica, non vende i tuoi dati ed è finanziato da pubblicità non invasiva.`)
};

const pt_br2_about_team_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A Toolverse é construída e mantida pelo Toolverse Team — um grupo pequeno e independente de engenheiros de software. O site não pertence a nenhuma empresa de mídia, não vende seus dados e é financiado por publicidade discreta.`)
};

const pt_about_team_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A Toolverse é construída e mantida pela Toolverse Team — um pequeno grupo independente de engenheiros de software. O site não pertence a nenhuma empresa de comunicação, não vende os seus dados e é financiado por publicidade discreta.`)
};

const ja_about_team_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ToolverseはToolverse Team — 独立した少人数のソフトウェアエンジニアチームによって構築・運営されています。当サイトはメディア企業の所有物ではなく、あなたのデータを販売することもなく、控えめな広告によって運営されています。`)
};

const zh_about_team_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toolverse 由 Toolverse Team 构建和维护——一个规模不大的独立软件工程师团队。本站不属于任何媒体公司，不出售你的数据，并通过不打扰的广告获得资金支持。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const about_team_p1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.about_team_p1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("about_team_p1", locale)
	if (locale === "en") return en_about_team_p1(inputs)
	if (locale === "es") return es_about_team_p1(inputs)
	if (locale === "de") return de_about_team_p1(inputs)
	if (locale === "nl") return nl_about_team_p1(inputs)
	if (locale === "fr") return fr_about_team_p1(inputs)
	if (locale === "it") return it_about_team_p1(inputs)
	if (locale === "pt-BR") return pt_br2_about_team_p1(inputs)
	if (locale === "pt") return pt_about_team_p1(inputs)
	if (locale === "ja") return ja_about_team_p1(inputs)
	return zh_about_team_p1(inputs)
};